import React, { useEffect, useState } from 'react';
import { staticConfig } from '../../../config/static';
import { IUserToken } from '../../../interfaces/login.interfaces';
import { AskCprView } from '../askcprview/AskCPRView';
import { FormRedirect } from '../formredirect/FormRedirect';

interface IAskCprProps {
    cprLessUserToken: string;
    cprLessUserType: string;
}
export const AskCpr = (props: IAskCprProps): JSX.Element => {
    const [userToken, setUserToken] = useState(null);
    const [type, setType] = useState(null);
    const [loading, setLoading] = useState(true);
    const classicLogonPlace = props.cprLessUserType === 'cvr' ? 'erhverv' : 'privat';
    const url = staticConfig.authenticateUserTokenEndpoint.replace('{domainType}', classicLogonPlace);

    useEffect(() => {
        setLoading(false);
        setUserToken(props.cprLessUserToken);
        setType(props.cprLessUserType);
    }, [props.cprLessUserToken, props.cprLessUserType]);

    function setDataToPost(data: IUserToken) {
        setUserToken(data.userToken);
    }

    console.log('type', type, userToken);

    return (
        <>
            {loading ? (
                <div />
            ) : userToken ? (
                <FormRedirect userToken={userToken} domainType={classicLogonPlace} endpoint={url} />
            ) : (
                <AskCprView setDataToPost={setDataToPost} />
            )}
        </>
    );
};
